'use client'

import { Button } from "@inflow/ui/components/button"
import { Input } from "@inflow/ui/components/input"
import { useRouter } from "next/navigation"
import { checkPassword } from "../actions"
import HeroContainer from "./HeroContainer"
import HeroTitle from "./HeroTitle"

export default function ComingSoon() {
  const router = useRouter()

  async function handleForm(formData: FormData) {
    const result = await checkPassword(formData)
    if (result.success) {
      router.refresh() // Triggers the layout to re-check the cookie
    } else {
      alert(result.error)
    }
  }

  return (
    <div className="-mt-6 px-3">
      <HeroContainer>
        <HeroTitle
          desktopAlignment="center"
          title="Minack Advisors"
          subTitle="Our new platform is currently under construction."
        >

          <form action={handleForm} className="mt-8 flex flex-col items-center gap-4">
            <Input
              name="password" // Key used in formData.get('password')
              type="password"
              placeholder="Enter Dev Password"
              required
            />
            <Button type="submit">
              Access Preview
            </Button>
          </form>
        </HeroTitle>
      </HeroContainer>
    </div>
  )
}
